import {
  baseRouteMakerForSuperAdmin,
  routes,
} from "../../../constants/routeConsts";
import { t } from "i18next";

export const useNotifyMenuUtils = () => {
  const tempMenuGroup = [];

  /* menuItemNotify */
  const menuItemNotify = {
    id: "notify",
    title: t("AppModuleNames.SuperAdmin.Notify"),
    url: baseRouteMakerForSuperAdmin(routes.NOTIFY),
  };
  tempMenuGroup.push(menuItemNotify);

  return tempMenuGroup;
};
